import { getContext, setContext } from 'svelte';

const KEY = Symbol('book-accordion-deps');

/**
 * Internal: used by <BookAccordionProvider> to publish deps into Svelte context.
 *
 * @param {object} deps
 * @param {object} deps.access - { hasRole, hasContentAction, canAccessResource, canAccessTeacherOnlyMaterial, currentUser }
 * @param {object} deps.db - { getEntity, getEntityBreadcrumb, getEntitiesWhere, getFirestore, contentDb }
 *   `contentDb` is the Firestore instance bound to the `content-db` named
 *   database — used for `read-only-titles/...` docPath reads. Falls back
 *   to `getFirestore()` if not provided.
 * @param {object} [deps.functions] - { callable } — optional; pass null to disable cacheLibraryResources calls
 * @param {object} [deps.features] - { isContentVisibilityEnabled } — optional feature-flag gates
 */
export function setBookAccordionDeps(deps) {
    setContext(KEY, deps);
}

export function getBookAccordionDeps() {
    const deps = getContext(KEY);
    if (!deps) {
        throw new Error(
            '@repo/book-accordion: context not set. Wrap your usage in <BookAccordionProvider>.'
        );
    }
    return deps;
}
